import React, { useEffect, useState } from "react";
import { useRef } from "react";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import { styled } from "@mui/material/styles";
import {
    FormControlLabel,
    Checkbox,
    FormGroup,
    List,
    ListItem,
    Typography,
    FormLabel,
    Radio,
    RadioGroup,
} from "@mui/material";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import axios from "../../../../lib/axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useLocation } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import checkAndLock from "../../../../GlobalFunction/checkAndLock";
import axiosInstance from "../../../../lib/axios";
import { formatDeleteErrorMessage } from "../../../../GlobalFunction/ErrorMessageHelper";
import UnLock from "../../../../GlobalFunction/UnLock";
import CrudButtons from "../../../../GlobalFunction/CrudButtons";
import ReportTable from "../../../../atoms/ReportFolder/ReportTable";
import { useReactToPrint } from "react-to-print";
import { getFormMode } from "../../../../lib/helpers";
import { z } from "zod";


const FORM_MODE = getFormMode();

const hsnChapFormSchema = z.object({
    HsnChap_Name: z.string().min(1, "Chaptername is required"),
    // HsnChap_Name: z.string().optional(),
    HsnChap_Desc: z.string().optional(),
    Remk: z.string().optional(),
    Status: z.enum(["1", "0"]).optional(),
});
const FORM_INIT_STATE = {
    HsnChp_Key: "",
    HsnChap_Name: "",
    HsnChap_Desc: "",
    Remk: "",
    Status: FORM_MODE.add ? "1" : "0",
};

const columns = [
    { id: "RowNum", label: "Sr.No.", minWidth: 5 },
    { id: "HsnChp_Key", label: "ChapterKey", minWidth: 100 },
    { id: "HsnChap_Name", label: "ChapterName", minWidth: 100 },
    { id: "Remk", label: "Remark", minWidth: 100 },
    { id: "Status", label: "Status", minWidth: 50 },
];

const GstChapHdMst = () => {
    const [formData, setFormData] = useState(FORM_INIT_STATE);
    const navigate = useNavigate();
    const [UserId, setUserId] = useState(sessionStorage.getItem("UserId"));
    const [isFormDisabled, setIsFormDisabled] = useState(true);
    const [location, setLocation] = useState(useLocation());
    const [Status, setStatus] = useState("1");
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [DataForPrint, setDataForPrint] = useState({});
    const [rows, setRows] = useState([]);
    const [GstType, setGstType] = useState("Goods");


    const [currentHsnChp_Key, setCurrentHsnChp_Key] = useState(() => {
        if (location.state && location.state?.HsnChp_Key) {
            return location.state && location.state?.HsnChp_Key;
        }
        return undefined;
    });
    const [mode, setMode] = useState(() =>
        currentHsnChp_Key ? FORM_MODE.read : FORM_MODE.add
    );

    const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState({
        isOpen: false,
        payload: null,
    });

    const contentRef = useRef(null);
    const handlePrint = useReactToPrint({ contentRef });

    const HsnChp_KeyRef = useRef(null);
    const HsnChap_NameRef = useRef(null);
    const HsnChap_DescRef = useRef(null);
    const RemkRef = useRef(null);


    useEffect(() => {
        const getRow = async () => {
            try {
                const res = await axiosInstance.post('HsnCode/GetGstChapDashBoard', {
                    start: 1,
                    PageSize: 1,
                    SearchText: "",
                });
                if (res.data && res.data.Data) {
                    setRows(res.data.Data);
                    setDataForPrint(res.data.Data);
                } else {
                    console.error('No data found in response');
                }
            } catch (err) {
                console.error('Error fetching data:', err);
            }
        };

        getRow();
    }, []);

    useEffect(() => {
        const state = location.state;

        if (state?.mode === "add" && state?.HsnChp_Key) {
            // Coming from Table "New" button with pre-generated key
            setCurrentHsnChp_Key(state.HsnChp_Key);
            setMode(FORM_MODE.add);
            setIsFormDisabled(false);
            setFormData({
                HsnChp_Key: state.HsnChp_Key,
                HsnChap_Name: "",
                HsnChap_Desc: "",
                Remk: "",
                Status: "1",
            });
            setGstType("Goods");
            setStatus("1");

            // Focus the first field
            setTimeout(() => HsnChp_KeyRef.current?.focus(), 100);
        }
        else if (state?.HsnChp_Key && state?.mode === "view") {
            setCurrentHsnChp_Key(state.HsnChp_Key);
            fetchRetriveData(state.HsnChp_Key, "R");
            setMode(FORM_MODE.read);
        }
        else {
            // Default add mode (no key passed)
            setMode(FORM_MODE.add);
            setIsFormDisabled(false);
            setFormData(FORM_INIT_STATE);
        }
    }, [location.state]);


    const fetchRetriveData = async (id, flag = "") => {
        if (!id) return;
        try {
            const response = await axiosInstance.post(
                `HsnCode/RetriveGstChap`,
                {
                    HsnChp_Key: id,
                    Flag: flag,
                }
            );
            const {
                data: { Status, Data },
            } = response;
            if (Status === 0 && Array.isArray(Data)) {
                setFormData({
                    HsnChp_Key: Data[0].HsnChp_Key,
                    HsnChap_Name: Data[0].HsnChap_Name,
                    HsnChap_Desc: Data[0].HsnChap_Desc || "",
                    Remk: Data[0].Remk || "",
                    Status: Data[0].Status,
                });
                setStatus(Data[0].Status.toString());

                // ADD THIS: Set GstType based on Gst_Type from API
                setGstType(Data[0].Gst_Type === "S" ? "Services" : "Goods");

                setIsFormDisabled(true);
                setCurrentHsnChp_Key(Data[0].HsnChp_Key);
                return Data[0].HsnChp_Key;
            }
        } catch (error) {
            console.error("Error fetching ticket hsn chapter", error);
        }
    };
    const fetchNextHsnCodeKey = async () => {
        try {
            const res = await axiosInstance.post('/HsnCode/GetSeriesLastNewKey', {
                ModuleName: "GstChap",
                TblName: "GstChap",
                ColName: "HsnChp_Key",
                Ncollen: 5,
                CPrefix: "GC",
                FLAG: ""
            });

            if (res.data.Status === 0 && res.data.Data?.[0]?.DocKey) {
                return res.data.Data[0].DocKey; // "GH003"
            }
            throw new Error("Invalid response");
        } catch (err) {
            toast.error("Failed to generate HSN Code Key");
            return "GH001";
        }
    };
    const handlePrevious = async () => {
        if (!currentHsnChp_Key) return;

        // Extract number from "GH001", "GH002", "ABC123" → 1, 2, 123
        const currentNum = parseInt(currentHsnChp_Key.match(/\d+/)?.[0] || "0", 10);

        if (currentNum > 1) {
            await fetchRetriveData(currentHsnChp_Key, "P");
        } else {
            toast.info("You are at the first record", { autoClose: 500 });
        }
    };


    const handleNext = async () => {
        if (currentHsnChp_Key) {
            await fetchRetriveData(currentHsnChp_Key, "N");
        }
    };

    const handleEdit = () => {
        setMode(FORM_MODE.edit);
        setIsFormDisabled(false);
    };

    const handleAdd = async () => {
        const nextKey = await fetchNextHsnCodeKey();

        setCurrentHsnChp_Key(nextKey);
        setMode(FORM_MODE.add);
        setIsFormDisabled(false);
        setFormData({
            HsnChp_Key: nextKey,
            HsnChap_Name: "",
            HsnChap_Desc: "",
            Remk: "",
            Status: "1",
        });
        setGstType("Goods");

        // Focus first *editable* field (Chapter Name)
        setTimeout(() => HsnChap_NameRef.current?.focus(), 100);
    };

    const handleExit = () => {
        navigate("/gst-chapter-heading-table", { replace: true });
    };

    const handleDelete = () => {
        setOpenConfirmDialog(true);
    };

    const handleCloseConfirmDialog = () => {
        setOpenConfirmDialog(false);
    };


    const handleConfirmDelete = async () => {
        setOpenConfirmDialog(false);

        if (!currentHsnChp_Key) {
            toast.error("No record to delete");
            return;
        }

        try {
            const response = await axiosInstance.post("/HsnCode/DeleteGstChap", {
                HsnChp_Key: currentHsnChp_Key,
            });

            const { Status, Message, Data } = response.data;

            if (Status === 0) {
                toast.success(Message || "Deleted successfully!", { autoClose: 1000 });

                await fetchRetriveData(currentHsnChp_Key, "N");

            } else {
                const errorMsg = Array.isArray(Data) && Data.length > 0
                    ? formatDeleteErrorMessage(Data)
                    : Message || "Delete failed";
                toast.error(errorMsg, { autoClose: 2000 });
            }
        } catch (error) {
            console.error("Delete error:", error);
            toast.error("Failed to delete record");
        }
    };


    const handleChangeStatus = (event) => {
        const updatedStatus = event.target.checked ? "1" : "0";
        setStatus(updatedStatus);
        setFormData((prevState) => ({
            ...prevState,
            Status: updatedStatus,
        }));
    };

    const handleKeyPress = (event) => {
        if (event.key === "Enter") {
            const refs = [HsnChap_NameRef, HsnChap_DescRef, RemkRef];
            const currentIdx = refs.findIndex(ref => ref.current === event.target);
            if (currentIdx > -1 && currentIdx < refs.length - 1) {
                refs[currentIdx + 1].current?.focus();
            }
        }
    };

    const handleSubmit = async () => {
        const result = hsnChapFormSchema.safeParse(formData);
        if (!result.success) {
            toast.error("Please fill required details.");
            return;
        }
        const { data } = result;
        const payload = {
            HsnChp_Key: formData.HsnChp_Key,
            HsnChap_Name: data.HsnChap_Name,
            Gst_Type: GstType === "Goods" ? "G" : "S",
            HsnChap_Desc: data.HsnChap_Desc || "",
            Remk: data.Remk || "",
            Status: data.Status,
        };

        let response;
        try {
            if (mode === FORM_MODE.edit) {
                payload.HsnChp_Key = currentHsnChp_Key;
                payload.Updated_By = parseInt(UserId, 10);
                response = await axiosInstance.patch(
                    `/HsnCode/UpdateGstChap`,
                    payload
                );
            } else {
                payload.Created_By = parseInt(UserId, 10);
                response = await axiosInstance.post(
                    `HsnCode/InsertGstChap`,
                    payload
                );
            }

            const {
                data: { Status, Data, Message },
            } = response;

            if (Status === 0) {
                toast.success(Message, { autoClose: 1000 });

                if (mode === FORM_MODE.add && Data?.HsnChp_Key) {
                    setCurrentHsnChp_Key(Data?.HsnChp_Key);
                    await fetchRetriveData(Data?.HsnChp_Key);
                    setMode(FORM_MODE.read);
                    setIsFormDisabled(true);

                } else {
                    setMode(FORM_MODE.read);
                }
                setIsFormDisabled(true);
            }else{
                 toast.error(Message, { autoClose: 1000 });
            }
        } catch (error) {
            console.error("Error during submit:", error);
        }
    };

    const handleCancel = async () => {
        if (mode === FORM_MODE.add) {
            try {
                await fetchRetriveData(1, "L");
                setMode(FORM_MODE.read);
                setIsFormDisabled(true);
            } catch (error) {
                toast.error('Error occurred while cancelling. Please try again.');
            }
        } else if (mode === FORM_MODE.edit) {
            if (currentHsnChp_Key) {
                await fetchRetriveData(currentHsnChp_Key, "R");
            }
            setMode(FORM_MODE.read);
            setIsFormDisabled(true);
        }
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    return (
        <>
            <Box
                className="form-container"
                sx={{
                    width: { xs: "calc(100vw - 60px)", sm: "auto", md: "auto" },
                    maxWidth: { xs: "calc(100vw - 60px)", sm: "auto", md: "auto" },
                    overflowX: "hidden",
                    overflowY: { xs: "auto", sm: "hidden", md: "hidden" },
                }}
            >
                <ToastContainer />
                <Grid
                    container
                    spacing={2}
                    sx={{
                        width: { xs: "93%", sm: "80%", md: "80%" },
                        height: { xs: "460px", sm: "auto", md: "auto" },
                        margin: "auto",
                        marginTop: { xs: "60px", sm: 0, md: "auto" },
                        marginBottom: { xs: "110px", sm: 0, md: "auto" },
                        borderRadius: "8px",
                        padding: { xs: "0px 5px 5px 5px", sm: "0px 20px 20px 20px" },
                        backgroundColor: "#fff",
                    }}
                >
                    <Grid
                        item
                        xs={12}
                        className="form_title"
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            marginTop: "30px",
                            marginInline: { xs: "0px", sm: "2px", md: "20px" },
                            flexDirection: { xs: "column", sm: "row", md: "row" },
                            overflow: "hidden",
                        }}
                    >
                        <Grid
                            sx={{
                                display: "flex",
                                justifyContent: { xs: "center", sm: "flex-start" },
                                marginBottom: { xs: "10px", sm: 0 },
                            }}
                        >
                            <Button
                                variant="contained"
                                size="small"
                                className="three-d-button-previous"
                                onClick={handlePrevious}
                                sx={{
                                    backgroundColor: "#635BFF",
                                    marginRight: { xs: "0px", sm: "10px" },
                                    display: "block",
                                }}
                                disabled={
                                    mode !== FORM_MODE.read ||
                                    !currentHsnChp_Key ||
                                    currentHsnChp_Key === 1
                                }
                            >
                                <KeyboardArrowLeftIcon />
                            </Button>
                            <Button
                                variant="contained"
                                size="small"
                                className="three-d-button-next"
                                onClick={handleNext}
                                sx={{
                                    backgroundColor: "#635BFF",
                                    display: "block",
                                }}
                                disabled={mode !== FORM_MODE.read || !currentHsnChp_Key}
                            >
                                <NavigateNextIcon />
                            </Button>
                        </Grid>
                        <Typography
                            variant="h5"
                            sx={{
                                margin: "auto",
                                textAlign: { xs: "center", sm: "center" },
                                fontSize: { xs: "22px", sm: "18px", md: "24px" },
                            }}
                        >
                            GST Chapter Heading
                        </Typography>
                        <Grid sx={{ display: "flex", justifyContent: "end" }}>
                            <CrudButtons
                                moduleName="Gst Chapter Heading"
                                mode={mode}
                                onAdd={handleAdd}
                                onEdit={handleEdit}
                                onDelete={handleDelete}
                                onView={handlePrint}
                                onExit={handleExit}
                                onPrevious={handlePrevious}
                                onNext={handleNext}
                                readOnlyMode={mode === FORM_MODE.read}
                            />
                        </Grid>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            mx: "auto",
                        }}
                    >
                        <Grid
                            container
                            spacing={1}
                            justifyContent="center"
                            sx={{ maxWidth: "800px", width: "100%" }}
                        >
                            <Grid item xs={12} md={8}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={3}>
                                        <TextField
                                            id="HsnChp_Key"
                                            // name="HsnChp_Key"
                                            label="Code"
                                            variant="filled"
                                            fullWidth
                                            disabled={true}
                                            className="custom-textfield"
                                            value={formData.HsnChp_Key}
                                            onChange={handleInputChange}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={9}>
                                        <TextField
                                            id="HsnChap_Name"
                                            name="HsnChap_Name"
                                            label={
                                                <>
                                                    Chapter Name <span style={{ color: "red" }}>*</span>
                                                </>
                                            }
                                            variant="filled"
                                            fullWidth
                                            className="custom-textfield"
                                            value={formData.HsnChap_Name}
                                            onChange={handleInputChange}
                                            disabled={mode !== FORM_MODE.add}
                                            inputRef={HsnChap_NameRef}
                                            onKeyDown={handleKeyPress}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                md={8}
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    flexDirection: 'row',
                                    gap: 2,
                                }}
                            >
                                <FormLabel
                                    component="legend"
                                    sx={{
                                        fontWeight: 500,
                                        whiteSpace: 'nowrap',
                                        mr: 2,
                                    }}
                                >
                                    GST Type
                                </FormLabel>

                                <RadioGroup
                                    row
                                    name="GstType"
                                    value={GstType}
                                    onChange={(e) => setGstType(e.target.value)}
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                    }}
                                >
                                    <FormControlLabel
                                        value="Goods"
                                        control={<Radio />}
                                        label="Goods"
                                        disabled={mode === FORM_MODE.read}
                                        sx={{ mr: 2 }}
                                    />
                                    <FormControlLabel
                                        value="Services"
                                        control={<Radio />}
                                        label="Services"
                                        disabled={mode === FORM_MODE.read}
                                    />
                                </RadioGroup>
                            </Grid>

                            <Grid item xs={12} md={8}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={12}>
                                        <TextField
                                            fullWidth
                                            label="Description"
                                            name="HsnChap_Desc"
                                            value={formData.HsnChap_Desc}
                                            onChange={handleInputChange}
                                            variant="filled"
                                            disabled={mode === FORM_MODE.read}
                                            className="custom-textfield"
                                            inputRef={HsnChap_DescRef}
                                            onKeyDown={handleKeyPress}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs={12} md={8}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={12}>
                                        <TextField
                                            fullWidth
                                            label="Remark"
                                            name="Remk"
                                            value={formData.Remk}
                                            onChange={handleInputChange}
                                            variant="filled"
                                            disabled={mode === FORM_MODE.read}
                                            className="custom-textfield"
                                            inputRef={RemkRef}
                                            onKeyDown={handleKeyPress}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} md={8}>
                                <FormGroup sx={{ flexShrink: 0 }}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                disabled={mode === FORM_MODE.read}
                                                checked={Status === "1"}
                                                onChange={handleChangeStatus}
                                            />
                                        }
                                        label="Status"
                                    />
                                </FormGroup>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        className="form_button"
                        sx={{ marginBottom: "10px", marginInline: "20px" }}
                    >
                        {mode === FORM_MODE.read && (
                            <>
                                <Button
                                    variant="contained"
                                    sx={{
                                        mr: 1,
                                        background: "linear-gradient(290deg, #d4d4d4, #ffffff)",
                                        "@media (max-width: 600px)": {
                                            padding: "0px 0px !important",
                                        },
                                    }}
                                    onClick={handleSubmit}
                                    disabled
                                >
                                    Submit
                                </Button>
                                <Button
                                    variant="contained"
                                    sx={{
                                        mr: 1,
                                        background: "linear-gradient(290deg, #a7c5e9, #ffffff)",
                                        "@media (max-width: 600px)": {
                                            padding: "0px 0px !important",
                                        },
                                    }}
                                    onClick={handleCancel}
                                    disabled
                                >
                                    Cancel
                                </Button>
                            </>
                        )}
                        {(mode === FORM_MODE.edit || mode === FORM_MODE.add) && (
                            <>
                                <Button
                                    variant="contained"
                                    sx={{
                                        mr: 1,
                                        "@media (max-width: 600px)": {
                                            padding: "0px 0px !important",
                                        },
                                    }}
                                    onClick={handleSubmit}
                                >
                                    Submit
                                </Button>
                                <Button
                                    variant="contained"
                                    sx={{
                                        mr: 1,
                                        "@media (max-width: 600px)": {
                                            padding: "0px 0px !important",
                                        },
                                    }}
                                    onClick={handleCancel}
                                >
                                    Cancel
                                </Button>
                            </>
                        )}
                    </Grid>
                </Grid>

                <div style={{ display: "none" }}>
                    {rows.length > 0 && (
                        <ReportTable
                            columns={columns}
                            rows={rows.map(row => ({
                                ...row,
                                Status: row.Status === "1" ? "Active" : row.Status === "0" ? "Inactive" : row.Status,
                            }))}
                            title="GST Chapter Heading"
                            contentRef={contentRef}
                            customStyles={{ backgroundColor: "#f5f5f5" }}
                        />
                    )}
                </div>
                <Dialog
                    open={openConfirmDialog}
                    onClose={handleCloseConfirmDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{"Confirm Deletion"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Are you sure you want to delete this record?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            sx={{
                                backgroundColor: "#635bff",
                                color: "white",
                                "&:hover": {
                                    backgroundColor: "#1565c0",
                                    color: "white",
                                },
                            }}
                            onClick={handleConfirmDelete}
                        >
                            Yes
                        </Button>
                        <Button
                            sx={{
                                backgroundColor: "#635bff",
                                color: "white",
                                "&:hover": {
                                    backgroundColor: "#1565c0",
                                    color: "white",
                                },
                            }}
                            onClick={handleCloseConfirmDialog}
                        >
                            No
                        </Button>
                    </DialogActions>
                </Dialog>
            </Box> {/* Added closing Box tag */}
        </>
    );
};

export default GstChapHdMst;